<template>
  <div>
    <el-dialog :close-on-click-modal="false"
      title="订单信息"
      :visible.sync="infoDialogVisible"
      :before-close="infoHandleClose"
      width="1400px"
      center
      top="5vh"
    >
      <el-divider></el-divider>
      <div class="infoForm">
          <div class="form_input">
              <div class="input_box">
                 <span>订单号：</span>
                 <el-input v-model="info.order_number" disabled></el-input>
              </div>
              <div  class="input_box">
                 <span>销售渠道：</span>
                 <el-input v-model="info.way=='1'?'微商城':'小程序'"  disabled>
                
                 </el-input>
              </div>
              <div  class="input_box">
                 <span>下单时间：</span>
                 <el-input v-model="info.created_at" disabled></el-input>
              </div>
              <div class="notes">
                 <span>订单总额：</span>
                 <el-input v-model="info.order_amount" disabled></el-input>
              </div>
              <!-- <div  class="input_box">
                 <span>验证码：</span>
                 <el-input v-model="input" disabled></el-input>
              </div> -->
              <!-- <div  class="input_box_peopo">
                 <span>观影人：</span>
                 <el-input v-model="input" disabled></el-input>
              </div> -->
          </div>
          <div style="margin-top:1.8rem;">
            <el-table
              :data="info.order_detail"
              :header-cell-style="tableHeaderColor"
              :cell-style="cellStyle"
              style="width: 100%"

            >
              <el-table-column  prop="movie_name"   label="演出名称"></el-table-column>
              <el-table-column prop="time" label="场次时间">
              </el-table-column>
              <el-table-column  prop="order_code" label="核销码">
              </el-table-column>
              
              <el-table-column  prop="mobile" label="手机号">
              </el-table-column>
              <el-table-column  prop="name"  label="观影人">
              </el-table-column>
              <el-table-column  prop="seat_name"  label="座位号">
              </el-table-column>
              <el-table-column  prop="area_name" label="区域名称">
              </el-table-column>
              <el-table-column   label="订单渠道">
                <template slot-scope="scope">
                  {{scope.row.way=='1'?'微商城':'小程序'}}
                </template>
              </el-table-column>
              <el-table-column   label="是否可退">
                <template slot-scope="scope">
                  {{scope.row.is_refund=='1'?'是':'否'}}
                </template>
              </el-table-column>
              <el-table-column  label="操作" >
              <template slot-scope="scope">
                  <div class="operation">
                    <div class="add_bianji" @click="openerwe(scope.row)">二维码</div>
                  </div>
              </template>
            </el-table-column>
            </el-table>
          </div>
          <!-- <div class="bottom_button">
              <div>打印</div>
              <div>验票</div>
          </div> -->
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
        title="二维码"
        :visible.sync="Visibleimg"
        :before-close="Closeimg"
        width="360px"
        center
      >
        <el-divider></el-divider>
        <div class="erweima">
          <img :src="img" alt="">
        </div>
      </el-dialog>
  </div>
</template>
<script>
import { getMovieOrderInfo } from "@/request/scenic.js"
export default {
  data(){
    return{
      infoDialogVisible:false,
      input:'',
      product:[
        {
          column:'',
          row:''
        }
      ],
      info:'',
      Visibleimg:false,
      img:''
    }
  },
  methods:{
    openerwe(row){
      this.img = 'http://home.softykt.net/index/ifsm.html?code=' +  row.order_code
      this.Visibleimg = true
    },
    Closeimg(){
      this.Visibleimg = false
      this.img = ''
    },
    seeInfo(row){
      console.log(row)
      let data = {
        token:window.sessionStorage.getItem('Token'),
        id:row.id  
      }
      getMovieOrderInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.info = res.data.result
        }
      })
      this.infoDialogVisible = true
    },
    infoHandleClose(){
      this.infoDialogVisible = false
      this.$emit('orderClose')
    },
      // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
  }
}
</script>
<style lang="less" scoped>
.form_input{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  >div{
    display: flex;
    align-items: center;
    margin-right: 2rem;
    margin-bottom: 2rem;
    ::v-deep .el-input{
      width: 18rem;
    }
  }
  .input_box_peopo{
    width: 100%;
    ::v-deep .el-input{
      width: 90%;
    }
  }
  .notes{
    ::v-deep .el-input{
      width: 14rem;
    }
  }
}
.bottom_button{
  margin-top: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  div{
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    &:nth-child(1){
      border: 1px solid #246DEB;
      color: #246DEB;
    }
    &:nth-child(2){
     background: #246DEB;
     color: #fff;
     margin-left: 2rem;
    }
  }
}
.add_bianji{
  color: #246DEB;
  font-size: 1.4rem;
  margin-right: 2rem;
  cursor: pointer;
}
.erweima{
  height: 30rem;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>